/**
 * The FAQs for `/tools/bulk-csv-checker`, in their own module so the route's
 * `head` (never code-split) doesn't pull in the tool. Rendered on the page and
 * emitted as `FAQPage` JSON-LD from the same list.
 */
export const BULK_CSV_CHECKER_FAQS = [
  {
    q: "What columns does a social media CSV need?",
    a: "Four: text, image_url, tags and posting_time. Only text is required. image_url must be a direct https link to the image file, tags are comma-separated names that already exist in your workspace, and posting_time is a date and time like 2027-03-14 09:30. Leave posting_time blank and the post goes to the next open slot in your queue instead.",
  },
  {
    q: "Which timezone is posting_time in?",
    a: "The one you pick when you import, read as wall-clock time. So 2027-03-14 09:30 with Europe/London selected goes out at half past nine London time, whatever timezone your computer is in. The checker uses the timezone you choose above so its answer matches the import.",
  },
  {
    q: "Can I bulk upload to Instagram, TikTok and Pinterest?",
    a: "Yes, as long as every row has an image URL, because none of the three can publish a post without media. TikTok rows become photo posts. Pinterest also needs a board, which you choose once for the whole file when you import. YouTube can't be bulk uploaded, because it needs a video and the CSV takes image URLs only.",
  },
  {
    q: "Is my CSV uploaded anywhere?",
    a: "No. The file is read and checked in your browser, and nothing is sent to PostDaily or anywhere else until you import it into your own workspace.",
  },
  {
    q: "Why does the checker pass a row that the import still rejects?",
    a: "Tags. The checker can't see your workspace, so it doesn't know which tag names exist, and the import rejects a tag your workspace doesn't have. Create the tags first, or leave the column blank. Everything else, from dates to image links to text length, is checked with the same code the import uses.",
  },
] as const;
